import { useEffect, useReducer } from "react";

import { calculateWinner, findBestMove } from "../utils/utils";
import Board from "./Board";
import GameModeActions from "./GameModeActions";
import classes from "./Game.module.css";

const initialGame = {
    board: Array.from({ length: 10 }, () => Array(6).fill(null)),
    isXNext: true,
    gameover: false,
    difficulty: "intermediate",
    winner: { player: null, winningCombination: null }
};

const gameStateReducer = (state, action) => {
    let newState;
    switch (action.type) {
        case "MOVE":
            newState = { ...state, board: state.board.map(col => [...col]) };

            for (let i = 5; i >= 0; i--) {
                if (newState.board[action.col][i] === null) {
                    newState.board[action.col][i] = state.isXNext ? "X" : "O";

                    const { player, winningCombination } = calculateWinner(newState.board);

                    if (player) {
                        newState.winner = { player, winningCombination };
                        newState.gameover = true;
                    } else if (newState.board.every(col => col.every(cell => cell !== null))) {
                        newState.gameover = true;
                    } else {
                        newState.isXNext = !state.isXNext;
                    }

                    return newState;
                }
            }
            return newState;
        case "RESET":
            return {
                board: Array.from({ length: 10 }, () => Array(6).fill(null)),
                isXNext: true,
                gameover: false,
                difficulty: "intermediate",
                winner: { player: null, winningCombination: null }
            };
        case "MODE_CHANGE":
            newState = { ...state, board: state.board.map(col => [...col]), difficulty: action.mode };
            return newState;
        default:
            return {
                board: Array.from({ length: 10 }, () => Array(6).fill(null)),
                isXNext: true,
                gameover: false,
                difficulty: "intermediate",
                winner: { player: null, winningCombination: null }
            };
    }
}

const Game = () => {
    const [gameState, dispatchGameState] = useReducer(gameStateReducer, initialGame);

    const { isXNext, gameover, board, winner, difficulty } = gameState;
    let currentGame = board;

    useEffect(() => {
        if (!isXNext && !winner.player) {
            let bestMove = findBestMove(currentGame, 3);

            let randomMove = Math.floor(Math.random() * 10);
            while (currentGame[randomMove][0 === null]) {
                randomMove = Math.floor(Math.random() * 10);
            }

            let move;
            let randomNumber = Math.ceil(Math.random() * 20);

            switch (difficulty) {
                case "easy":
                    if (randomNumber > 13) {
                        move = randomMove;
                    } else {
                        move = bestMove;
                    }
                    break;
                case "intermediate":
                    if (randomNumber > 17) {
                        move = randomMove;
                    } else {
                        move = bestMove;
                    }
                    break;
                case "expert":
                    if (randomNumber > 19) {
                        move = randomMove;
                    } else {
                        move = bestMove;
                    }
                    break;
                default:
                    move = bestMove;
            }

            const delay = setTimeout(() => {
                dispatchGameState({ type: "MOVE", col: move });
            }, Math.floor(Math.random() * 500) + 500);

            return () => clearTimeout(delay);
        }
    }, [isXNext, winner, currentGame, difficulty]);

    const handleMove = (col) => {
        if (!isXNext || gameover || currentGame[col].every(cell => cell)) {
            return;
        }

        dispatchGameState({ type: "MOVE", col });
    };

    const handleReset = () => {
        dispatchGameState("RESET");
    }

    const handleModeChange = difficulty => {
        dispatchGameState({ type: "MODE_CHANGE", mode: difficulty });
    }

    const status = winner.player ? `Winner: ${winner.player === "X" ? "RED" : "BLUE"}` : gameover ? "Draw!" : (isXNext ? "It's your turn!" : "");

    return <div className={classes.game}>
        <div className={`${classes.action} ${winner.player ? (winner.player === "X" ? classes["action-red"] : classes["action-blue"]) : gameover ? classes["action-over"] : ""}`}>
            <p>{status}</p>
            <button onClick={handleReset}>RESET</button>
        </div>
        <Board isXNext={isXNext} onMove={handleMove} board={gameState.board} winner={winner} gameover={gameover} />
        <GameModeActions onModeChange={handleModeChange} difficulty={difficulty} />
    </div>
}

export default Game;